module.exports = __webpack_public_path__ + "static/media/signup-login-bg.460c394c.jpg";